var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"property-view",attrs:{"id":"admin-property-view"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"md":"12"}},[_c('user-table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }